var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',{staticClass:"mt-n12"},[_c('NavDrawer',{attrs:{"mini":_vm.mini},on:{"drawerToggled":function($event){_vm.mini = $event}}}),_c('AppBar',{attrs:{"drawer":_vm.drawer}}),_c('v-container',{staticClass:"mt-15",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }